import { render } from "./PageHeaderMultimediaHeader.vue?vue&type=template&id=6ce70ff5&scoped=true"
import script from "./PageHeaderMultimediaHeader.vue?vue&type=script&lang=js"
export * from "./PageHeaderMultimediaHeader.vue?vue&type=script&lang=js"

import "./PageHeaderMultimediaHeader.vue?vue&type=style&index=0&id=6ce70ff5&scoped=true&lang=css"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce70ff5"]])

export default __exports__